// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_M0On1 {
  flex: 1 0 0;
  width: 100%;
}

.cardAreaGood_BLHLY {
  background-color: #029E2E !important;
}

.cardAreaGood_BLHLY * {
  color: white !important;
}

.cardAreaBad_gQGni {
  background-color: #DB253D !important;
}

.cardAreaBad_gQGni * {
  color: white !important;
}

.detailBox_O9rO1 * {
  color: #394756 !important;
}

.paceCardDetailContentGood_UeISD {
  color: #029E2E !important;
}

.paceCardDetailContentBad_vy6ds {
  color: #DB253D !important;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/factoryCycleTimeMonitoring/components/mobile/OverallPaceCard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".card {\n  flex: 1 0 0;\n  width: 100%;\n}\n\n.cardAreaGood {\n  background-color: #029E2E !important;\n}\n\n.cardAreaGood * {\n  color: white !important;\n}\n\n.cardAreaBad {\n  background-color: #DB253D !important;\n}\n\n.cardAreaBad * {\n  color: white !important;\n}\n\n.detailBox * {\n  color: #394756 !important;\n}\n\n.paceCardDetailContentGood {\n  color: #029E2E !important;\n}\n\n.paceCardDetailContentBad {\n  color: #DB253D !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card_M0On1`,
	"cardAreaGood": `cardAreaGood_BLHLY`,
	"cardAreaBad": `cardAreaBad_gQGni`,
	"detailBox": `detailBox_O9rO1`,
	"paceCardDetailContentGood": `paceCardDetailContentGood_UeISD`,
	"paceCardDetailContentBad": `paceCardDetailContentBad_vy6ds`
};
export default ___CSS_LOADER_EXPORT___;
